module.exports = __webpack_public_path__ + "static/media/vgu-logo.a29cbfab.jpg";